import { Button, Modal, Popconfirm, Space } from "antd"
import { Pencil, Trash2 } from "lucide-react"
import { useState } from "react";
import { ParticipantForm } from "./ParticipantForm";
import { ExamPeriod, ExamPeriodState, User } from "@types";
import { useTranslation } from "react-i18next";
import { useEditExamPeriod } from "@hooks";

interface Props {
    participant?: User;
    examPeriod?: ExamPeriod;
}

export const ExamParticipantTableActions = ({participant, examPeriod}: Props) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const {t} = useTranslation();
    const examPeriodEdit = useEditExamPeriod();

    return (
        <>
        
        <Space>
            <Button disabled={examPeriod?.state !== ExamPeriodState.InActive} onClick={() => setIsModalOpen(true)} icon={<Pencil/>}/>
            <Popconfirm
                title={t("pages.examPeriods.applicantsTab.deleteUser")}
                disabled={examPeriod?.state !== ExamPeriodState.InActive}
                onConfirm={() => {
                    examPeriodEdit.mutate({
                    ...examPeriod,
                    userExaminees: examPeriod!.userExaminees.filter((participantt) => participantt.id !== participant!.id)
                  })
                }}
                description={t("pages.examPeriods.applicantsTab.deleteUserDesc")}
                okButtonProps={{ loading: examPeriodEdit.isPending }}
                icon={<Trash2  style={{ color: "red", marginRight: 8 }} />}
              >
                <Button disabled={examPeriod?.state !== ExamPeriodState.InActive} danger icon={<Trash2/>}/>
              </Popconfirm>
            
        </Space>

        <Modal
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
            title={t("pages.examPeriods.applicantsTab.editUser")}
            destroyOnClose
        >
            <ParticipantForm participant={participant}/>
        </Modal>
        </>
    )
}